import React from 'react'
import {Divider, Drawer} from '@mui/material'

import * as Constants from '~/src/constants'
import { Logo } from '~/src/components/atoms'
import { DrawerHeader } from './PersistentDrawer.styles'

export type TPersistentDrawerProps = {
  drawerOpen?: boolean
  children: React.ReactChild
}

const drawerWidth = Constants.DRAWER_WIDTH

/**
 * PersistentDrawer Component
 *
 * @example
 * ```ts
 *  <PersistentDrawer />
 * ```
 * @param __namedParameters TPersistentDrawerProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const PersistentDrawer: React.FC<TPersistentDrawerProps> = ({
  drawerOpen = true,
  children,
}): JSX.Element => (
  <Drawer
    sx={{
      width: drawerWidth,
      flexShrink: 0,
      '& .MuiDrawer-paper': {
        width: drawerWidth,
        boxSizing: 'border-box',
      },
    }}
    variant="persistent"
    anchor="left"
    open={drawerOpen}
  >
    <DrawerHeader>
      <Logo />
    </DrawerHeader>
    {children}
    <Divider/>
  </Drawer>
)
